import { CHECKOUT_RECIPE } from '@/lib/constants';
import { Attachment, RecipeType } from '@/types';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export interface CheckoutRecipeState {
  recipe_type: RecipeType | null;
  selected_recipe: any;
  recipe_date: string;
  recipe_digital_token: string;
  recipe_fisical_file: Attachment | null;
  recipe_fisical_file_name: string;
  recipe_owner_type: string;
  recipe_valid: boolean;
  accepted_recipe_types: string[];
  shipping_zip: string;
  shipping_address: string | null;
}

const defaultCheckoutRecipe: CheckoutRecipeState = {
  recipe_type: null,
  selected_recipe: {},
  recipe_date: '',
  recipe_digital_token: '',
  recipe_fisical_file: null,
  recipe_fisical_file_name: '',
  recipe_owner_type: '',
  recipe_valid: false,
  accepted_recipe_types: [],
  shipping_zip: '',
  shipping_address: null,
};

export const checkoutRecipeAtom = atomWithStorage(
  CHECKOUT_RECIPE,
  defaultCheckoutRecipe,
);

export const updateCheckoutRecipeAtom = atom(
  (get) => get(checkoutRecipeAtom),
  (get, set, update: Partial<CheckoutRecipeState>) => {
    set(checkoutRecipeAtom, { ...get(checkoutRecipeAtom), ...update });
  },
);

export const clearRecipeCheckoutAtom = atom(null, (_get, set, _data) => {
  return set(checkoutRecipeAtom, defaultCheckoutRecipe);
});
